(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luem-contact-utilities"] && !Shopify.designMode) return;
  try {
    const initLuemScrollReveal = () => {
    const hero = document.querySelector('#MainContent > .shopify-section.hero-wrapper');
    const heroCandidates = hero ? hero.querySelectorAll(':is(h1, h2, h3, .text-block, .button)') : [];
    const heroTargets = [...heroCandidates].filter((element) => !element.querySelector('h1, h2, h3, .button'));
    heroTargets.forEach((element, index) => {
      element.classList.remove('luem-scroll-reveal', 'luem-scroll-reveal--heading', 'luem-scroll-reveal--text', 'is-visible');
      element.classList.add('luem-hero-intro');
      element.style.setProperty('--luem-hero-delay', `${160 + (index * 170)}ms`);
    });

    const candidates = document.querySelectorAll('#MainContent .shopify-section :is(h1, h2, h3, .text-block, .rte > p)');
    const targets = [...candidates].filter((element) => !hero?.contains(element) && !element.querySelector('h1, h2, h3, .rte > p'));
    targets.forEach((element, index) => {
      element.classList.add('luem-scroll-reveal');
      element.classList.add(element.matches('h1, h2, h3') ? 'luem-scroll-reveal--heading' : 'luem-scroll-reveal--text');
      element.style.setProperty('--luem-reveal-delay', `${(index % 4) * 95}ms`);
      element.style.setProperty('--luem-reveal-x', `${index % 2 === 0 ? -18 : 18}px`);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    targets.forEach((element) => observer.observe(element));

    const resellerText = [...document.querySelectorAll('[id$="__media_with_content_RqxiU3"] p')].find((element) => element.textContent.replace(/\s+/g, ' ').trim().toLocaleLowerCase('it') === 'diventa nostro rivenditore');
    if (!resellerText) return;
    resellerText.classList.add('luem-reseller-emphasis');
    const resellerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.65) return;
        entry.target.classList.add('is-emphasized');
        resellerObserver.unobserve(entry.target);
      });
    }, { threshold: 0.65 });
    resellerObserver.observe(resellerText);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuemScrollReveal, { once: true });
  } else {
    initLuemScrollReveal();
  }
  } catch(e) { console.error(e); }
})();

})();
